import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//helpers
import {getErrorResponse} from '@/utils/helpers';
import {IUserOrganizationSettingData, IUserSettingReqData} from '@/utils/types';
import {AdminNotificationSettingService} from '@/utils/services/admin-notificationsSettings';

// get admin notification setting
export const adminGetNotificationSettings = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_LIST,
	async (adminId: number, {rejectWithValue}) => {
		try {
			const adminResponse: AxiosResponse<IUserOrganizationSettingData> =
				await AdminNotificationSettingService.getAllNotificationSetting(adminId);
			return adminResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

//update admin notification setting
export const adminUpdateNotificationSettings = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_UPDATE_LIST,
	async ({id, reqBody}: IUserSettingReqData, {rejectWithValue}) => {
		try {
			const adminResponse: AxiosResponse<IUserOrganizationSettingData> =
				await AdminNotificationSettingService.updateNotificationSetting(id, reqBody);
			return adminResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
